import { FormEvent } from 'react'
import { useQueryClient, useMutation } from '@tanstack/react-query'
import { tableService } from '../../../../../../app/services/tableService'
import { useToast } from '../../../../../components/ui/use-toast'
import { useAtom } from 'jotai'
import { selectedTableCardInfo } from '../../../../../../app/store'

export const useRemoveTableCardController = () => {
  const queryClient = useQueryClient()
  const [selectedTableCard] = useAtom(selectedTableCardInfo)

  const { toast } = useToast()

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['deleteTable'],
    mutationFn: async ({ tableId }: { tableId: string }) =>
      await tableService.removeTable(tableId),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['allTables'],
      })
    },
  })

  const handleRemoveTable = async (
    event: FormEvent<HTMLFormElement>,
    tableId: string,
  ) => {
    event.preventDefault()
    try {
      const response = await mutateAsync({ tableId })

      if (response.success) {
        toast({
          title: 'Tabela removida com sucesso',
        })
      }
    } catch (error) {
      console.log(error)
      toast({
        variant: 'destructive',
        title: 'Erro ao remover a tabela, tente novamente mais tarde.',
      })
    }
  }

  return {
    handleRemoveTable,
    isPending,
    selectedTableCard,
  }
}
